const baseUrl = process.env.API_ROOT || '';
const baseUrlMe = process.env.API_ROOTS || '';
export default {

	// 微信分享
	"getAccessToken": baseUrl + "wechat/getAccessToken", // 获取accessToken
	"getJsapiTicket": baseUrl + "wechat/getJsapiTicket", // 获取jsapi_ticket(暂时用不到)
	"getSignature": baseUrl + "wechat/getSignature", // 获取signature(暂时用不到)
	"handler": baseUrl + "wechat/handler", // 校验信息是否是从微信服务器发出，处理消息(暂时用不到)

	//刷新token接口(匿名)
	"hiddenToken": baseUrlMe + "api/user/token/000000",

	//获取短信的接口
	"smsMsg": baseUrlMe + "api/sms/msg",

	//个人预约
	"person": baseUrlMe + "api/user/mask/person",
	//企业预约
	"personEnt": baseUrlMe + "api/user/mask/ent",
	
   // 我的预约
   "reserves": baseUrlMe + "api/user/mask/reserves",
   // 查询我的收货地址
   "getMyAddress":baseUrlMe + "api/user/mask/address",
   // 新增收货地址
   "Addaddress":baseUrlMe + "api/user/mask/address/add",
   
   // 模糊查询企业信息
   "vague":baseUrlMe + "api/ent/info/vague",
   
   // 精确查询企业信息
   "accurate":baseUrlMe + "api/ent/info/accurate",
   
   //获取时间的接口
   "getActivityDate": baseUrl + "sysConfig/getActivityDate",

}



// WEBPACK FOOTER //
// ./src/api/api.js